import Language from "../services/translation/language";
import { translationService } from "../services/translation/TranslationService";

export const normalise = (value: number, total: number) => {
  return value > total ? 100 : (value / total) * 100;
};

export const toRemainingPercentage = (used: number, total: number) => {
  return Math.floor(100 - (used / total) * 100);
};

export const teraToBytes = (tera: number) => {
  return parseFloat((tera * 1024 * 1024 * 1024 * 1024).toFixed(0));
};

export const roundToTwoDecimals = (value: number) => Math.round(value * 100) / 100;

export const getUniqueKey = () => Math.floor(Math.random() * Date.now());

interface StorageFormat {
  amount: number;
  unit: string;
}

export const formatBytes = (bytes: number, decimals = 2): StorageFormat => {
  if (bytes === 0) return { amount: 0, unit: "B" };

  const byteSize = 1024;
  const units = ["B", "KB", "MB", "GB", "TB"];

  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(byteSize)), units.length - 1);

  return {
    amount: parseFloat((bytes / Math.pow(byteSize, i)).toFixed(decimals)),
    unit: units[i],
  };
};

export const secondsToMinutesAndSeconds = (totalSeconds: number): string => {
  if (isNaN(totalSeconds)) return "";

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);
  return `${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
};

export const getLocalPrice = (price: number): string => {
  const priceWithDecimals = price.toFixed(2);

  return formatNumberBasedOnLanguage(priceWithDecimals);
};

export const formatNumberBasedOnLanguage = (value: any) => {
  if (!value) return;

  if (translationService.language === Language.german) return value.replace(".", ",");
  else return value.replace(",", ".");
};
